// components/CartSidebar.jsx
import React from 'react';
import { useCart } from '../CartContext';
import { Icons } from './Icons';

export default function CartSidebar({ onCheckout }) {
  const { cartItems, removeFromCart, updateQty, cartTotal, isCartOpen, setIsCartOpen, userType, getDeliveryCharge, getFinalTotal } = useCart();
  const deliveryCharge = getDeliveryCharge();
  const finalTotal = getFinalTotal();

  const handleCheckout = () => {
    setIsCartOpen(false);
    if (onCheckout) onCheckout();
  };

  // Helper function to get image URL with fallback
  const getImageUrl = (item) => {
    if (item.image) {
      // Check if it's a valid URL or local path
      if (item.image.startsWith('http') || item.image.startsWith('/') || item.image.startsWith('./')) {
        return item.image;
      }
      // If it's just a filename, assume it's in assets/images
      return `/assets/images/products/${item.image}`;
    }
    return null;
  };

  // Handle image error
  const handleImageError = (e) => {
    e.target.style.display = 'none';
    // Show placeholder
    const parent = e.target.parentElement;
    if (parent && !parent.querySelector('.image-placeholder')) {
      const placeholder = document.createElement('div');
      placeholder.className = 'image-placeholder';
      placeholder.style.cssText = 'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #f3f4f6; color: #9ca3af; font-size: 2rem;';
      placeholder.innerText = '🛒';
      parent.appendChild(placeholder);
      e.target.style.display = 'none';
    }
  };

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          div[class*="cart-sidebar"] {
            padding: 0 !important;
            font-size: 14px !important;
          }
          div[class*="cart-sidebar"] > div:first-child > h2 {
            font-size: 12px !important;
            margin: 0 !important;
          }
          div[class*="cart-sidebar"] > div:first-child > span {
            font-size: 10px !important;
          }
          div[class*="cart-sidebar"] > div:first-child {
            padding: 0.75rem 0.75rem 0.5rem !important;
          }
          div[class*="cart-sidebar"] > div:nth-child(2) {
            padding: 0.5rem 0.75rem !important;
          }
          div[class*="cart-sidebar"] > div:last-child {
            padding: 0.75rem !important;
          }
          div[class*="cart-sidebar"] .qty-control {
            transform: scale(0.8);
            margin: 0 !important;
          }
          div[class*="cart-sidebar"] .qty-btn {
            width: 22px !important;
            height: 22px !important;
            font-size: 12px !important;
          }
          div[class*="cart-sidebar"] .qty-value {
            min-width: 20px !important;
            font-size: 11px !important;
          }
          div[class*="cart-sidebar"] button {
            min-height: 36px !important;
            font-size: 12px !important;
            padding: 6px 8px !important;
          }
          div[class*="cart-sidebar"] > div:nth-child(2) > div {
            padding: 8px 0 !important;
            gap: 8px !important;
          }
          div[class*="cart-sidebar"] > div:nth-child(2) > div > div:first-child {
            width: 45px !important;
            height: 45px !important;
          }
          div[class*="cart-sidebar"] > div:nth-child(2) > div > div:nth-child(2) {
            font-size: 12px !important;
          }
          div[class*="cart-sidebar"] > div:nth-child(2) > div > div:last-child {
            gap: 4px !important;
          }
          /* Subtotal styling */
          div[class*="cart-sidebar"] > div:last-child > div:first-child > div {
            font-size: 9px !important;
            color: #6b7280 !important;
            line-height: 1.3 !important;
          }
          div[class*="cart-sidebar"] > div:last-child > div:first-child > div:last-child {
            font-size: 11px !important;
            color: #111827 !important;
            font-weight: 800 !important;
          }
        }
        @media (max-width: 480px) {
          div[class*="cart-sidebar"] {
            font-size: 12px !important;
          }
          div[class*="cart-sidebar"] > div:first-child > h2 {
            font-size: 10px !important;
            margin: 0 !important;
          }
          div[class*="cart-sidebar"] > div:first-child > span {
            font-size: 9px !important;
          }
          div[class*="cart-sidebar"] > div:first-child {
            padding: 0.5rem 0.5rem 0.4rem !important;
          }
          div[class*="cart-sidebar"] > div:nth-child(2) {
            padding: 0.4rem 0.5rem !important;
          }
          div[class*="cart-sidebar"] > div:last-child {
            padding: 0.5rem !important;
          }
          div[class*="cart-sidebar"] .qty-control {
            transform: scale(0.75);
          }
          div[class*="cart-sidebar"] .qty-btn {
            width: 20px !important;
            height: 20px !important;
            font-size: 10px !important;
          }
          div[class*="cart-sidebar"] .qty-value {
            min-width: 18px !important;
            font-size: 10px !important;
          }
          div[class*="cart-sidebar"] button {
            min-height: 32px !important;
            font-size: 11px !important;
            padding: 4px 6px !important;
          }
          div[class*="cart-sidebar"] > div:nth-child(2) > div {
            padding: 6px 0 !important;
            gap: 6px !important;
          }
          div[class*="cart-sidebar"] > div:nth-child(2) > div > div:first-child {
            width: 40px !important;
            height: 40px !important;
          }
          div[class*="cart-sidebar"] > div:nth-child(2) > div > div:nth-child(2) {
            font-size: 11px !important;
          }
          div[class*="cart-sidebar"] > div:nth-child(2) > div > div:last-child {
            gap: 2px !important;
          }
          /* Subtotal styling for small mobile */
          div[class*="cart-sidebar"] > div:last-child > div:first-child > div {
            font-size: 8px !important;
            color: #6b7280 !important;
            line-height: 1.2 !important;
          }
          div[class*="cart-sidebar"] > div:last-child > div:first-child > div:last-child {
            font-size: 10px !important;
            color: #111827 !important;
            font-weight: 800 !important;
          }
          div[class*="cart-sidebar"] > div:last-child > button {
            padding: 8px !important;
            font-size: 11px !important;
          }
        }
      `}</style>
      {/* Overlay */}
      <div
        className={`cart-overlay ${isCartOpen ? 'active' : ''}`}
        onClick={() => setIsCartOpen(false)}
      />

      {/* Sidebar */}
      <div className={`cart-sidebar ${isCartOpen ? 'open' : ''}`}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1.25rem 1.5rem', borderBottom: '1px solid #e5e7eb' }}>
          <div>
            <h2 style={{ fontWeight: 700, fontSize: '1rem', margin: 0, color: '#111827' }}>
              Cart
            </h2>
            <span style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
              {cartItems.reduce((s, i) => s + i.qty, 0)} item{cartItems.reduce((s, i) => s + i.qty, 0) !== 1 ? 's' : ''}
            </span>
          </div>
          <button onClick={() => setIsCartOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#374151', padding: '4px', borderRadius: '6px', display: 'flex' }}
            onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
            onMouseLeave={e => e.currentTarget.style.background = 'none'}>
            <Icons.Close size={22} />
          </button>
        </div>

        {/* Items */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '1rem 1.5rem' }}>
          {cartItems.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#9ca3af', marginTop: '3rem' }}>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
                <Icons.Cart size={56} style={{ color: '#d1d5db' }} />
              </div>
              <p style={{ fontWeight: 600, marginBottom: '4px', color: '#374151' }}>
                Your cart is empty
              </p>
              <p style={{ fontSize: '0.8125rem' }}>Add items to get started</p>
            </div>
          ) : (
            <>
              {/* Mixed cart info */}
              {cartItems.filter(i => !i.isB2B).length > 0 && cartItems.filter(i => i.isB2B).length > 0 && (
                <div style={{ background: '#eff6ff', color: '#1e40af', borderRadius: '8px', padding: '10px 14px', marginBottom: '1rem', fontSize: '0.8125rem', fontWeight: 500 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                    <Icons.Cart size={18} />
                    Mixed cart: B2C + B2B items
                  </span>
                </div>
              )}

              {/* Free delivery badge */}
              {cartTotal >= 50000 && cartItems.filter(i => i.isB2B).length > 0 ? (
                <div style={{ background: '#fef2f2', color: '#991b1b', borderRadius: '8px', padding: '10px 14px', marginBottom: '1rem', fontSize: '0.8125rem', fontWeight: 500 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                    <Icons.Truck size={18} />
                    You've got <strong>FREE delivery!</strong> <a href="#!" onClick={handleCheckout} style={{ color: '#dc2626', fontWeight: 700 }}>Checkout now!</a>
                  </span>
                </div>
              ) : cartItems.filter(i => i.isB2B).length > 0 ? (
                <div style={{ background: '#fef3c7', color: '#92400e', borderRadius: '8px', padding: '10px 14px', marginBottom: '1rem', fontSize: '0.8125rem', fontWeight: 500 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                    <Icons.Truck size={18} />
                    Add ₹{(50000 - cartTotal).toFixed(2)} more for FREE delivery
                  </span>
                </div>
              ) : null}

              {cartItems.map(item => (
                <div key={`${item.isB2B ? 'b2b' : 'b2c'}-${item.id}`} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 0', borderBottom: '1px solid #f3f4f6' }}>
                  {/* Product Image */}
                  <div style={{ 
                    width: 60, 
                    height: 60, 
                    border: '1px solid #e5e7eb', 
                    borderRadius: '8px', 
                    overflow: 'hidden', 
                    flexShrink: 0, 
                    background: '#fafafa',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative'
                  }}>
                    {/* B2B/B2C Badge */}
                    <div style={{
                      position: 'absolute',
                      top: '-2px',
                      right: '-2px',
                      background: item.isB2B ? '#8b5cf6' : '#16a34a',
                      color: 'white',
                      fontSize: '0.6rem',
                      fontWeight: 700,
                      padding: '1px 4px',
                      borderRadius: '4px',
                      zIndex: 1
                    }}>
                      {item.isB2B ? 'B2B' : 'B2C'}
                    </div>
                    
                    {item.image && item.image !== '🛒' ? (
                      <img 
                        src={getImageUrl(item)} 
                        alt={item.name}
                        style={{ 
                          width: '100%', 
                          height: '100%', 
                          objectFit: 'cover'
                        }}
                        onError={handleImageError}
                      />
                    ) : (
                      <div style={{ 
                        width: '100%', 
                        height: '100%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        background: '#f3f4f6', 
                        fontSize: '2rem' 
                      }}>
                        {item.icon || '🛒'}
                      </div>
                    )}
                  </div>
                  
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '0.875rem', fontWeight: 600, color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginBottom: '2px' }}>{item.name}{item.unit ? ` (${item.unit})` : ''}</div>
                    <div style={{ fontSize: '0.75rem', color: '#9ca3af', marginBottom: '6px' }}>
                      {item.category || 'Item'} • {item.isB2B ? 'Wholesale' : 'Retail'}
                    </div>
                    <div style={{ fontSize: '1rem', fontWeight: 700, color: '#111827' }}>₹{item.price}{item.unit ? `/${item.unit}` : ''}</div>
                    {item.isB2B && <div style={{ fontSize: '0.68rem', color: '#8b5cf6', fontWeight: 600, marginTop: '2px' }}>Min: {item.minOrder || 1}</div>}
                  </div>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px', flexShrink: 0 }}>
                    <div className="qty-control">
                      <button className="qty-btn" onClick={() => updateQty(item.id, -1, item.isB2B, item.minOrder || 1)} disabled={item.isB2B && item.qty <= (item.minOrder || 1)} style={item.isB2B && item.qty <= (item.minOrder || 1) ? { opacity: 0.35, cursor: 'not-allowed' } : {}}>−</button>
                      <span className="qty-value">{item.qty}</span>
                      <button className="qty-btn" onClick={() => updateQty(item.id, 1, item.isB2B, item.minOrder || 1)}>+</button>
                    </div>
                    <button onClick={() => removeFromCart(item.id, item.isB2B)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '0.75rem', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '3px', padding: 0 }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0"/><path d="M10 11l0 6"/><path d="M14 11l0 6"/><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"/><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"/></svg>
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>

        {/* Footer */}
        {cartItems.length > 0 && (
          <div style={{ padding: '1.25rem 1.5rem', borderTop: '1px solid #e5e7eb', background: '#fff' }}>
            {/* Subtotal breakdown */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '1rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.9rem', color: '#6b7280' }}>
                <span>Item Total ({cartItems.reduce((s, i) => s + i.qty, 0)} item{cartItems.reduce((s, i) => s + i.qty, 0) !== 1 ? 's' : ''})</span>
                <span style={{ fontWeight: 600, color: '#374151' }}>₹{cartTotal.toFixed(2)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.9rem', color: '#16a34a' }}>
                <span>Delivery Charges</span><span style={{ fontWeight: 600 }}>{deliveryCharge > 0 ? `₹${deliveryCharge.toFixed(2)}` : 'FREE'}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.9rem', color: '#6b7280' }}>
                <span>GST</span><span style={{ fontWeight: 600, color: '#374151' }}>₹0.00</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 800, fontSize: '1.125rem', color: '#111827', borderTop: '1px solid #e5e7eb', paddingTop: '10px', marginTop: '4px' }}>
                <span>Grand Total</span>
                <span style={{ color: '#16a34a' }}>₹{finalTotal.toFixed(2)}</span>
              </div>
            </div>

            <button onClick={handleCheckout}
              style={{ width: '100%', padding: '12px', background: '#16a34a', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 700, fontSize: '0.9375rem', cursor: 'pointer', marginBottom: '8px', transition: 'background 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.background = '#15803d'}
              onMouseLeave={e => e.currentTarget.style.background = '#16a34a'}>
              Proceed to Checkout →
            </button>
            <button onClick={() => setIsCartOpen(false)}
              style={{ width: '100%', padding: '10px', background: 'transparent', color: '#374151', border: '1px solid #d1d5db', borderRadius: '8px', fontWeight: 500, fontSize: '0.875rem', cursor: 'pointer' }}>
              Continue Shopping
            </button>
          </div>
        )}
      </div>
    </>
  );
}